export type CollapseState<T> = {
  isOpen: boolean;
  $target: T;
};

const collapse = <T extends HTMLElement>($trigger: HTMLElement, forcedState?: boolean): Promise<CollapseState<T>> => {
  const currentlyOpen = $trigger.getAttribute('aria-expanded') === 'true';
  const controls = $trigger.getAttribute('aria-controls');

  if (!controls) {
    return Promise.reject();
  }

  const $target = document.getElementById(controls) as T;

  if (!$target) {
    return Promise.reject();
  }

  const isOpen = forcedState ?? !currentlyOpen;
  $trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  $target.hidden = !isOpen;

  return Promise.resolve({
    isOpen,
    $target,
  });
};

export default collapse;
